(function() {
  function updateCartDrawer(parsedState) {
    if (parsedState.sections && parsedState.sections['cart-drawer']) {
      const existingDrawer = document.querySelector('cart-drawer');
      if (existingDrawer) {
        existingDrawer.outerHTML = parsedState.sections['cart-drawer'];
      }
    }

    const newDrawer = document.querySelector('cart-drawer');
    if (newDrawer) {
      if (typeof newDrawer.open === 'function') {
        newDrawer.open();
      } else {
        newDrawer.setAttribute('open', 'open');
      }
    }
  }

  function updateCartCount(qtyToAdd) {
    const icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;

    let bubble = icon.querySelector('.cart-count-bubble');
    let countSpan;

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';

      countSpan = document.createElement('span');
      countSpan.setAttribute('aria-hidden', 'true');
      countSpan.textContent = '0';

      const srSpan = document.createElement('span');
      srSpan.className = 'visually-hidden';
      srSpan.textContent = '';

      bubble.appendChild(countSpan);
      bubble.appendChild(srSpan);
      icon.appendChild(bubble);
    } else {
      countSpan = bubble.querySelector('span[aria-hidden="true"]');
      if (!countSpan) {
        countSpan = document.createElement('span');
        countSpan.setAttribute('aria-hidden', 'true');
        bubble.insertBefore(countSpan, bubble.firstChild);
      }
    }

    let current = parseInt((countSpan.textContent || '0').replace(/[^\d]/g, ''), 10);
    if (isNaN(current)) current = 0;

    const newCount = current + qtyToAdd;
    countSpan.textContent = newCount;

    const srSpan2 = bubble.querySelector('.visually-hidden');
    if (srSpan2) {
      srSpan2.textContent = newCount;
    }
  }

  function triggerThemeCartRefresh() {
    let attempts = 0;
    const maxAttempts = 20;

    const interval = setInterval(function() {
        attempts++;

        const drawer = document.querySelector('cart-drawer');
        if (!drawer) {
        if (attempts >= maxAttempts) clearInterval(interval);
        return;
        }

        const qtyInput =
        drawer.querySelector('quantity-input input.quantity__input') ||
        drawer.querySelector('.cart-item__quantity input') ||
        drawer.querySelector('input[name^="updates"]');

        if (qtyInput) {
        clearInterval(interval);
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (attempts >= maxAttempts) {
        clearInterval(interval);
        }
    }, 30);
  }

  function handleUpsellSubmit(form) {
    if (!form || form.dataset.kwUpsellLoading === 'true') return;

    form.dataset.kwUpsellLoading = 'true';

    const formData = new FormData(form);
    let qty = parseInt(formData.get('quantity') || '1', 10);
    if (isNaN(qty) || qty < 1) qty = 1;

    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(function(response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function(parsedState) {
        updateCartDrawer(parsedState);
        updateCartCount(qty);

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:updated', { detail: { source: 'upsell' } })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:open', { detail: { source: 'upsell' } })
        );

        triggerThemeCartRefresh();
      })
      .catch(function(error) {
        console.error('Upsell add-to-cart error:', error);
      })
      .finally(function() {
        form.dataset.kwUpsellLoading = 'false';
      });
  }

  document.addEventListener(
    'submit',
    function(event) {
      const form = event.target.closest('.kw-upsell__form[data-kw-upsell-form]');
      if (!form) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      handleUpsellSubmit(form);
    },
    true
  );

  document.addEventListener(
    'click',
    function(event) {
      const button = event.target.closest('.kw-upsell__button');
      if (!button) return;

      const form = button.closest('.kw-upsell__form[data-kw-upsell-form]');
      if (!form) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      handleUpsellSubmit(form);
    },
    true
  );

  document.addEventListener(
    'click',
    function(event) {
      const banner = event.target.closest('.kw-upsell__inner[data-kw-upsell-click]');
      if (!banner) return;

      const form = banner.querySelector('.kw-upsell__form[data-kw-upsell-form]');
      if (!form) return;

      const clickOnButton = event.target.closest('.kw-upsell__button');
      if (clickOnButton) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      handleUpsellSubmit(form);
    },
    true
  );
})();
